import React from 'react';
import '../../styles/confirm-delete-modal.css';

interface ConfirmDeleteModalProps {
  isOpen: boolean;
  itemName: string;
  itemType?: string;
  onConfirm: () => void;
  onCancel: () => void;
}

const ConfirmDeleteModal: React.FC<ConfirmDeleteModalProps> = ({
  isOpen,
  itemName,
  itemType = 'Item',
  onConfirm,
  onCancel,
}) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onCancel}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2 className="modal-title">Delete {itemType}</h2>
          <button className="modal-close" onClick={onCancel}>
            ×
          </button>
        </div>
        
        <div className="modal-body">
          <p className="modal-text">
            Are you sure you want to delete <strong>{itemName}</strong>?
          </p>
          <p className="modal-subtext">
            This action cannot be undone.
          </p>
        </div>
        
        <div className="modal-footer">
          <button className="modal-button modal-button--cancel" onClick={onCancel}>
            Cancel
          </button>
          <button className="modal-button modal-button--delete" onClick={onConfirm}>
            Delete
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDeleteModal;

